export default __webpack_public_path__ + "static/media/money-back@3x.06e0f3d5.png";